module.exports = __webpack_public_path__ + "img/stavropol-logotype.63de439f.svg";